// 🔑 WHEN THE DOWN PAYMENT IS DUE (Jesse, 2026-11-01). Mirror of backend/constants/downPaymentDue.js — the date the
// server sets, the program agreement's words and the SmartEstimate card's tooltips all read this one number;
// backend/test/downPaymentDue.test.js fails if the two files disagree.
export const DOWN_PAYMENT_DUE_BUSINESS_DAYS = 3;
export const DOWN_PAYMENT_DUE_PHRASE = `within ${DOWN_PAYMENT_DUE_BUSINESS_DAYS} business days of your contract effective date`;
